module.exports = __webpack_public_path__ + "img/id_step_01@2x.ec0a22fc.png";